<script setup>
import { computed, inject } from 'vue'
import { useFilters } from '#/general/useFilters'
const { pages } = inject('Shared')
const { prettifyNumber } = useFilters()

const props = defineProps(['volume', 'potentialVolume', 'blurred', 'height', 'width', 'smallTextFontSize'])
const potentialPercentage = computed(() => {
  return Math.round(((props.potentialVolume / (props.volume + props.potentialVolume)) * 100))
})
const potentialPercentageCss = computed(() => potentialPercentage.value + '%')
const potentialPercentageCssMax = computed(() => (potentialPercentage.value > 90 ? 90 : potentialPercentage.value) + '%')
const currentPercentage = computed(() => {
  return Math.round((props.volume / (props.volume + props.potentialVolume)) * 100)
})

const potentialBarCss = computed(() => {
  if (pages.value && pages.value.map && pages.value.map.quickView) {
    switch (true) {
      case (potentialPercentage.value < 20): return `background: ${pages.value.map.quickView.potentialVolumeLowBackground}; color: ${pages.value.map.quickView.potentialVolumeLowColor}`
      case (potentialPercentage.value >= 20 && potentialPercentage.value <= 30): return `background: ${pages.value.map.quickView.potentialVolumeMediumBackground}; color: ${pages.value.map.quickView.potentialVolumeMediumColor}`
      case (potentialPercentage.value > 30): return `background: ${pages.value.map.quickView.potentialVolumeHighBackground}; color: ${pages.value.map.quickView.potentialVolumeHighColor}`
    }
  }
  return 'background-color: #5FEFC0; color: #007BFF;'
})
</script>

<template lang='pug'>
.potentialVolumeBox(:class="blurred ? 'potential-volume--blur' : ''")
  .potentialVolumeContainer
    template(v-if="potentialVolume >= 0")
      .currentScore {{ currentPercentage + '%' }}
      .potentialContainer(:style="potentialBarCss")
        .potentialScore(:style="potentialPercentage <= 20 ? 'color: white;' : 'color: #007BFF'") {{ potentialPercentageCss }}

    .negativePotentialContainer(v-else)
      .row.items-center
        .labelOne kein Potenzial

  .volumesContainer
    .row.items-center
      .currentVolumeSign
      .currentVolumeLabel Ist-Volumen:
      .currentVolumeValue {{prettifyNumber(Math.round(volume), 0)}}m
        .smallText 3
    .row.items-center
      .potentialVolumeSign(:style="potentialBarCss")
      .potentialVolumeLabel Potenzial
      .potentialVolumeValue
        span(v-if="potentialVolume >= 0") {{prettifyNumber(potentialVolume, 0)}}m
          .smallText 3
        span(v-else) -
</template>

<style scoped lang='sass'>
.potential-volume--blur
  filter: blur(15px)
  -webkit-filter: blur(15px)
.potentialVolumeBox
  width: v-bind(width)
  .potentialVolumeContainer
    background-color: #DCE7F2
    width: 100%
    height: v-bind(height)
    border-radius: 4px
    position: relative
    display: flex
    align-items: center
    justify-content: center
    .negativePotentialContainer
      width: 100%
      height: 100%
      display: flex
      justify-content: center
      align-items: center
      border-radius: 4px
      background: #EB604F
      .labelOne
        font-style: italic
        font-weight: 500
        font-size: 14px
        line-height: 130%
        color: #FFFFFF
    .potentialContainer
      height: 100%
      right: 0px
      top: 0px
      position: absolute
      border-radius: 4px
      width: v-bind(potentialPercentageCssMax)
      display: flex
      justify-content: center
      align-items: center
      .potentialScore
        font-style: italic
        font-weight: bold
        font-size: 14px
        line-height: 130%
        margin-right: 5px
    .currentScore
      font-style: italic
      font-weight: 500
      font-size: 14px
      line-height: 130%
      color: #007BFF
      padding-right: v-bind(potentialPercentageCssMax)
    .levelMarker
      position: absolute
      bottom: -6px
      height: 6px
      width: 1px
      background: #626C85
      .label
        margin-top: 5px
        margin-left: -10px
        font-weight: 600
        font-size: 10px
        line-height: 130%
        color: #626C85
  .volumesContainer
    display: flex
    align-items: center
    justify-content: space-between
    width: 100%
    margin-top: 10px
    padding-right: 8px
    .currentVolumeSign
      width: 12px
      height: 9px
      background: #DCE7F2
      border-radius: 4px
      margin-right: 5px
    .currentVolumeLabel
      font-weight: 600
      font-size: v-bind(smallTextFontSize)
      line-height: 130%
      color: #626C85
      margin-right: 5px
    .currentVolumeValue
      font-weight: 500
      font-size: v-bind(smallTextFontSize)
      line-height: 130%
      color: #007BFF
      position: relative
    .potentialVolumeSign
      width: 12px
      height: 9px
      background: #5FEFC0
      border-radius: 4px
      margin: 0 5px
    .potentialVolumeLabel
      font-weight: 600
      font-size: v-bind(smallTextFontSize)
      line-height: 130%
      color: #626C85
      margin-right: 5px
    .potentialVolumeValue
      font-weight: 500
      font-size: v-bind(smallTextFontSize)
      line-height: 130%
      color: #007BFF
      position: relative
    .smallText
      position: absolute
      top: -4px
      right: -7px
      font-size: 10px
</style>
